import React from 'react';
import Navbar from './Navbar';
import { Route, Routes } from 'react-router-dom';
import Dashboard from '../../Pages/Dashboard/Dashboard';
import Footer from './Footer';
import Rent from '../../Pages/Dashboard/Rent';
import Wallet from '../../Pages/Dashboard/Wallet';
import Setting from '../../Pages/Dashboard/Setting';
import CompanyDashboard from '../../Pages/Dashboard/Company/Dashboard';
import Buy from '../../Pages/Dashboard/Buy';
import CoOwn from '../../Pages/Dashboard/CoOwn';
// import DashboardViewProperty from '../../Pages/Dashboard/DashboardViewProperty';
import AllEmployee from '../../Pages/Dashboard/Company/AllEmployee';
import EmployeeProfile from '../../Pages/Dashboard/Company/EmployeeProfile';
import { useSelector } from 'react-redux';
import { RootState } from '../../Storeredux/reducers/rootReducer';
import { Auth, userData } from '../../Storeredux/constants/actionTypes';
import Sidebar from './SideBar';
import Viewproperty from '../../Pages/Dashboard/Viewproperty';
import ViewCownProperty from '../../Pages/Dashboard/viewCownProperties';
import InspectedProperty from '../../Pages/Dashboard/InspectedProoperty';

function Layout() {
  const AuthState = useSelector((state: RootState) => state.auth as Auth);
  const { userType } = AuthState;
  const UserState = useSelector((state: RootState) => state.user as userData);
  const { user } = UserState;
  console.log('ghghggb', userType, user);

  return (
  <div className='relative h-screen flex'>
    <div className={'lg:w-[15%] lg:block hidden'}>
      <Sidebar />
    </div>
    <div className={'lg:w-[85%] w-full overflow-y-auto flex flex-col'}>
      <Navbar />
      <div className='bg-custom-white overflow-y-auto flex-1'>
        <Routes>
          <Route path='/dashboard' element={user?.user_type === 'admin' ? <CompanyDashboard /> : <Dashboard />} />
          <Route path='/rent' element={<Rent />} />
          <Route path='/allemployees' element={<AllEmployee />} />
          <Route path='/allemployees/:id' element={<EmployeeProfile />} />
          <Route path='/buy' element={<Buy />} />
          <Route path='/inspection' element={<InspectedProperty />} />
          <Route path='/co-own' element={<CoOwn />} />
          <Route path='/co-own/properties/:id' element={<ViewCownProperty />} />
          <Route path='/properties/:id' element={<Viewproperty />} />
          <Route path='/wallet' element={<Wallet />} />
          <Route path='/setting' element={<Setting />} />
        </Routes>
      </div>
      <Footer />
    </div>
  </div>
  )
  ;
}

export default Layout;
